<template>
    <div style="height:100%" class="m-checkRemark">
        <div class="checkRemark"  :style="{ height: h }"> 
            <steps :active="active" :step-list="stepList" :this-step="thisStep"/>
            <third-step ref="thirdStep" :check-remark="checkRemark" :this-step="thisStep"/>
        </div>
        <div class="footer">
            <el-button class="btnNew btnSize btn" @click="Upt">重新编辑</el-button>
        </div>
    </div>
</template>
<script>
    import steps from '@/components/steps';
    import API from '@/fetch/api';
    import thirdStep from '@/components/thirdStep';
    export default {
        components: {
            steps,
            thirdStep
        },
        data () {
            return {
                active:3,
                stepList:['选择入住园区','填写店铺服务商资料','审核未通过'],
                thisStep:3.3,
                checkRemark:'',
                h: `${ document.documentElement.clientHeight - 240 }px`
            }
        },
        created () {
            this.getcheckRemark ()
        },
        methods:{
            Upt () {
                this.$emit('showflag',1)
            },
            getcheckRemark () {
                API.http({
                    fullUrl: '/merchant/audit_info',
                    type:'POST',
                }).then(res=>{
                    if(res.code==200){
                        this.checkRemark = res.data.checkRemark
                    }
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
.m-checkRemark{
    .checkRemark{
        height: 100%;
        background-color: #fff;
        padding-bottom: 30px;
        border-radius: 4px;
    }
    .footer{
        background-color: #fff;
        padding: 20px;
        text-align: center;
        margin-top: 20px;
        margin-bottom: -20px;
    } 
}
    
    
</style>
<style lang="scss">
    .checkRemark{
        .m-thirdStep .audit{
            padding-top:0;
        }
    }
</style>